import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import gql from "graphql-tag";
import { Query } from "react-apollo";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import AddUserButton from "./add-user-button";
import EditUserButton from "./edit-user-button";
import DeleteUserButton from "./delete-user-button";

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  },
  fab: {
    position: "absolute",
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2
  }
});

const GET_USERS = gql`
  query allUsers {
    allUsers {
      id
      email
    }
  }
`;

class UsersDashboard extends Component {
  render() {
    const { classes } = this.props;

    return (
      <Row center="md">
        <Col xs={12} md={8} lg={8}>
          <Typography variant="h5" component="h3" className={classes.root}>
            Usuarios
          </Typography>
          <Paper className={classes.root}>
            <Query query={GET_USERS}>
              {({ loading, error, data }) => {
                if (loading) return "Loading...";
                if (error) return `Error! ${error.message}`;
                const { allUsers } = data;
                return (
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Correo electrónico</TableCell>
                        <TableCell>Acciones</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {allUsers.map(row => {
                        return (
                          <TableRow key={row.id}>
                            <TableCell component="th" scope="row">
                              {row.email}
                            </TableCell>
                            <TableCell component="th" style={{ maxWidth: 70 }} align="left">
                              <Row style={{flexWrap : "nowrap"}}>
                                <Col xs>
                                  <EditUserButton row={row} query={GET_USERS} />
                                </Col>
                                <Col xs>
                                  <DeleteUserButton
                                    row={row}
                                    query={GET_USERS}
                                  />
                                </Col>
                              </Row>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                );
              }}
            </Query>
            <AddUserButton query={GET_USERS} />
          </Paper>
        </Col>
      </Row>
    );
  }
}

export default withStyles(styles)(UsersDashboard);



// WEBPACK FOOTER //
// ./src/components/users/index.js